import {
  adjustPosition,
  CHART_HANDLERS_MAP,
  CHART_INITIALIZATIONS_MAP,
  CHART_TYPES,
} from './mock'

export async function getChart({
  chartMode,
  type = 'MTTs Full Ring',
  filter = null,
  isJson = false,
}) {
  const formData = new FormData()
  if (!filter) {
    formData.append('chart_type', type)
    formData.append('action', CHART_INITIALIZATIONS_MAP[chartMode])
  } else {
    formData.append('db', 'crawler')
    formData.append('rules', 'true')

    formData.append('action', CHART_HANDLERS_MAP[chartMode])
    formData.append('filter[type]', CHART_TYPES[filter.chartType])
    formData.append('filter[blinds]', filter.stack)
    const position =
      filter.chartType === 'CASH GAME'
        ? filter.position
        : adjustPosition(filter.position)
    formData.append('filter[position]', position)

    formData.append('filter[action]', filter.action)
    formData.append('data_format', isJson ? 'json' : 'html')
    if (filter.action !== 'RFI') formData.append('filter[opposition]', filter.oppos)
  }

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_charts${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export async function getMwChart({
  type = 'CASH HU',
  stack = 100,
  preflop_actions = '',
  rnid = null,
}) {
  const formData = new FormData()

  formData.append('action', 'preflop_chart_mw_handler')
  formData.append('filter[type]', type)
  formData.append('filter[blinds]', stack)
  formData.append('filter[preflop_actions]', preflop_actions)
  formData.append('filter[rnid]', rnid)


  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_charts${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}
